<template>
    <div class="userAnalysis spackage padding-20 bgc box-shadow">
        <div class="head">
            <div class="flex right">
                <el-input v-model="apidata.assname" placeholder="请输入社群名称" class="input item"></el-input>
                <el-button type="primary" @click="search" class="item">搜索</el-button>
            </div>
       </div>
       <el-table rel="singleTable" :data="tableInfo" @sort-change="sortChange">
            <el-table-column label="社群名称" property='assname' align="left">
            </el-table-column>

            <el-table-column label="用户数" sortable='custom' property='usercount' align="center">
            </el-table-column>
            <el-table-column label="总订单数" sortable='custom' property='ordercount' align="center">
            </el-table-column>
            <el-table-column label="总订单额" sortable='custom' property='ordermoney' align="center">
            </el-table-column>
            <el-table-column label="人均购买额" sortable='custom' property='paymoney' align="center">
            </el-table-column>
        </el-table>

        <!-- <el-pagination background layout="prev, pager, next" :total="totalPage" @current-change="fPage"></el-pagination> -->


    </div>
</template>

<script>
import { downloadImage} from 'common/js/tools'
import { mapActions} from 'vuex' // 引入 vuex 组件
import $ from 'jquery'
import {getAgbAnalysisdata} from 'api/cPurchaseApi'

    export default {
        name: "UserAnalysis",
        data() {
           return {
              tableInfo: [],    //表单数据
              totalPage: 0,    //数据条数
              currentPage: 1, // 当前页
              times: '', // 搜索时间
              apidata: {
                sortbyuser: '',
                sortbyorder: '',
                sortbyordermoney: '',
                sortbypay: '',
                assname: '',	// 社群名称
                // page: 1,       // 当前页数
                // pageSize: 10    // 每页展示条数
              }
          }
        },
        mounted() {
            this.activelist(1)
        },
        methods: {
            sortChange(even) {
                console.log(even)
                let fliedName = even.prop,
                    sortingType = even.order,
                    apidata = this.apidata,
                    txt = ''
                    
                    switch (fliedName) {
                        case "usercount":
                            if (sortingType == "ascending") { 
                                txt = "count(*) ASC"
                            } else if (sortingType == "descending") {
                                txt = "count(*) DESC"
                            } else {
                                txt = ''
                            }
                            apidata.sortbyuser = txt 
                            break
                        case "ordercount":
                            if (sortingType == "ascending") { 
                                txt = "sum(ordercount) ASC"
                            } else if (sortingType == "descending") {
                                txt = "sum(ordercount) DESC"
                            } else {
                                txt = ''
                            }
                            apidata.sortbyorder = txt
                            break
                        case "ordermoney":
                            if (sortingType == "ascending") { 
                                txt = "sum(ordermoney) ASC"
                            } else if (sortingType == "descending") {
                                txt = "sum(ordermoney) DESC"
                            } else {
                                txt = ''
                            }
                            apidata.sortbyordermoney = txt
                            break
                        case "paymoney":
                            if (sortingType == "ascending") { 
                                txt = "(sum(ordermoney)/sum(ordercount)) ASC"
                            } else if (sortingType == "descending") {
                                txt = "(sum(ordermoney)/sum(ordercount)) DESC"
                            } else {
                                txt = ''
                            }
                            apidata.sortbypay = txt
                            break
                    }
                // this.activelist(apidata.page)
                this.activelist()
            },
            activelist(page) {  // 活动列表
                // this.apidata.page = page    // 取得页数
                this.setLoading(true)
                getAgbAnalysisdata({
                    data: this.apidata,
                    success: data => {
                        this.setLoading(false)

                        this.tableInfo = data.data.content
                        this.totalPage = data.data.pageinfo.rowCount

                        console.log(data)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }   
                })
            },
            search() {  // 搜索
                this.activelist(1) 
            },  
            fPage(){    // 分页
                let clickPage = $(".el-pagination .active").html()
                // console.log($('clickPage',$(".el-pagination .active").html()))
                this.activelist(clickPage)
            },
            ...mapActions([
                'setLoading'
            ])
        },
        filters: {},
        watch: {},
        computed: {},
        components: {}
    }
</script>


<style lang="scss" type="text/scss">
.userAnalysis {
    .one-title {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .sub-title {
         display: -webkit-box;
         display: -webkit-inline-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        -moz-box-orient: vertical;
        -ms-box-orient: vertical;
        box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .el-input__icon {
        line-height: normal;
    }
    .head {
        margin-bottom: 30px;
    }

    .position,
    .head,
    .flex {
        display: flex;
        flex-wrap: nowrap;
        -ms-flex-wrap: nowrap;
        justify-content: flex-end;
        width: 100%;
        img {
            margin-right: 10px;
            width: 50px;
            height: 50px;
            border-radius: 50%;
        }
    }
        .flex.left {
            align-content: flex-start;
        }
        .flex.right {
            align-content: flex-end;
        }

        .head {
            .select {
                width: 108px;
            }
            .input {
                width: 220px;
            }
            .item {
                margin-left: 15px
            }
        }
        .el-pagination {
            margin-top: 20px;
            text-align: center;
        }

        .position {
            color: #439FFE;
            width: auto;
            float: right;

            p {
                margin: 0 5px;
                color: #439FFE;
                cursor: pointer;
            }
        }
}
    
</style>
